import './laxhjalpen-user-participation-widget.scss';
import { BizIcon } from '../../../../../FrontEndReact/src/Core/Components/Mini/BizIcon';
import { goto } from '../../../../../Js/React/Services/legacy';
import { useFrontendState } from '../../../../../FrontEnd/Common/frontendStateContext';
import {
	LhStudentParticipationStats,
	useGetLoggedInUserParticipationStats,
	useGetRelatedStudentParticipationStatsToLoggedInGuardian,
} from '../Services/laxhjalpenUserParticipation';

type LaxhjalpenUserParticipationWidgetProps = {
	hideOnNoData?: boolean;
	mode?: 'minimal' | 'default';
};

const LaxhjalpenUserParticipationWidget = ({
	hideOnNoData = false,
	mode = 'minimal',
}: LaxhjalpenUserParticipationWidgetProps) => {
	const { state } = useFrontendState();
	const isStudent = state.user?.Roles?.some((role) => role.SystemName === 'LH_STUDENT') ?? false;
	const isGuardian = state.user?.Roles?.some((role) => role.SystemName === 'LH_GUARDIAN') ?? false;
	const { data: studentStats, statusState: studentStatus } = useGetLoggedInUserParticipationStats(state.user?.Id, isStudent);
	const { data: guardianStudents, statusState: guardianStatus } = useGetRelatedStudentParticipationStatsToLoggedInGuardian(state.user?.Id, isGuardian);

	const guardianStats = guardianStudents.length > 0 ? guardianStudents[0] : null;
	const stats = studentStats ?? guardianStats;
	const isGuardianView = !studentStats && guardianStudents.length > 0;

	if (mode === 'default' && !studentStats) {
		return null;
	}

	if (!state.user || (!stats && (studentStatus === 'LOADING' || guardianStatus === 'LOADING'))) {
		return (
			<div className={`biz-lh-participation-widget biz-lh-participation-widget--${mode} biz-lh-participation-widget--loading`}>
				<BizIcon icon='LOADING' />
			</div>
		);
	}

	if (!stats) {
		if (hideOnNoData) {
			return null;
		}

		return (
			<div className={`biz-lh-participation-widget biz-lh-participation-widget--${mode} biz-lh-participation-widget--empty`}>
				<span className='biz-lh-participation-widget__label'>Deltagande</span>
				<span className='biz-lh-participation-widget__value'>-</span>
			</div>
		);
	}

	return (
		<button
			type='button'
			className={`biz-lh-participation-widget biz-lh-participation-widget--${mode}`}
			onClick={() => {
				goto(isGuardianView ? 'base.core.profile.participation' : 'base.core.profile.home');
			}}
		>
			<ParticipationWidgetContent stats={stats} mode={mode} isGuardianView={isGuardianView} />
		</button>
	);
};

export default LaxhjalpenUserParticipationWidget;

function ParticipationWidgetContent({
	stats,
	mode,
	isGuardianView,
}: {
	stats: LhStudentParticipationStats;
	mode: 'minimal' | 'default';
	isGuardianView: boolean;
}) {
	const attendancePercent = getPercent(stats.attendedCount, stats.eventCount);

	if (mode === 'default') {
		return (
			<div className='biz-lh-participation-widget__default-content'>
				<span className='biz-lh-participation-widget__default-label'>Närvaro</span>
				<div
					className='biz-lh-participation-widget__default-circle'
					style={{
						background: `conic-gradient(var(--biz-progressbar-fill, var(--biz-primary-accent-color-bg)) 0% ${attendancePercent}%, #e4ebf3 ${attendancePercent}% 100%)`,
					}}
				>
					<div className='biz-lh-participation-widget__default-circle-center'>{attendancePercent}%</div>
				</div>
				<div className='biz-lh-participation-widget__default-meta'>
					<div className='biz-lh-participation-widget__default-count'>
						{stats.attendedCount} av {stats.eventCount} pass
					</div>
					<div className='biz-lh-participation-widget__default-rank'>{stats.unitRank}:{stats.unitRank < 3 ? 'a' : 'e'} högst i gruppen</div>
				</div>
			</div>
		);
	}

	return (
		<div className='biz-lh-participation-widget__minimal-row'>
			<div
				className='biz-lh-participation-widget__minimal-circle'
				style={{
					background: `conic-gradient(var(--biz-progressbar-fill, var(--biz-primary-accent-color-bg)) 0% ${attendancePercent}%, #e4ebf3 ${attendancePercent}% 100%)`,
				}}
			>
				<div className='biz-lh-participation-widget__minimal-circle-center'>{attendancePercent}%</div>
			</div>
			<span className='biz-lh-participation-widget__minimal-label'>Närvaro</span>
			{isGuardianView && stats.user?.firstName ? (
				<span className='biz-lh-participation-widget__minimal-student-name'>{stats.user?.firstName}</span>
			) : null}
		</div>
	);
}

function getPercent(value: number, total: number) {
	if (total <= 0) return 0;
	return Math.round((value / total) * 100);
}